import { Pipe, PipeTransform } from '@angular/core';
import { QuestionnaireRequestService } from 'src/app/core/api/questionnaire-request.service';

@Pipe({
  name: 'questionnaireName'
})
export class QuestionnaireNamePipe implements PipeTransform {
  constructor(private questionnaireRequestService: QuestionnaireRequestService) {}

  transform(questionnaire: any): string {
    if (!questionnaire) {
      return '';
    }
    return this.questionnaireRequestService.getQuestionnaireFriendlyName(questionnaire);
  }
}
